var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Galéria - 2023")]),_c('image-galery',{attrs:{"subfolder":"galery2023"}}),_c('h2',[_vm._v("Galéria - 2021")]),_c('image-galery',{attrs:{"subfolder":"galery2021"}}),_c('h2',[_vm._v("Galéria - 2020")]),_c('image-galery',{attrs:{"subfolder":"galery2020"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }